/* Winkelwagen-lade, voorstel B (Claude): maat wijzigen, look toevoegen en levertijd. */
(function () {
  if (window.fzLade) return;
  window.fzLade = true;

  function lade() { return document.querySelector('cart-drawer'); }
  function secties() {
    var d = lade();
    return d && d.getSectionsToRender ? d.getSectionsToRender().map(function (s) { return s.section; }) : [];
  }
  // Op de winkelwagenpagina (/cart) herladen we na een wijziging, zodat pagina en lade allebei kloppen
  function pagina() { return document.getElementById('main-cart-items'); }
  function laden(aan) {
    var el = pagina() ? document.querySelector('cart-items') : document.querySelector('#CartDrawer-Body cart-drawer-items');
    if (el) el.classList.toggle('is-loading', aan);
  }
  function melding(t) {
    var m = document.querySelector(pagina() ? '[data-fzc-melding]' : '[data-fzl-melding]');
    if (m) { m.hidden = !t; m.textContent = t || ''; }
  }
  function post(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(data)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; });
    });
  }
  function voegToe(items) {
    return post('/cart/add.js', { items: items, sections: secties().join(','), sections_url: location.pathname });
  }
  function toon(j) {
    if (pagina()) { location.reload(); return; }
    var d = lade();
    if (d && d.renderContents && j.sections) d.renderContents(j);
  }

  // Maat wijzigen: oude regel eruit, nieuwe maat erin met hetzelfde aantal
  document.addEventListener('change', function (e) {
    var s = e.target;
    if (!s.matches || !s.matches('[data-fzl-maat]')) return;
    var nieuw = +s.value, oud = +s.dataset.oud, qty = +s.dataset.qty || 1;
    if (!nieuw || nieuw === oud) return;
    laden(true); melding('');
    post('/cart/change.js', { id: s.dataset.key, quantity: 0 })
      .then(function () { return voegToe([{ id: nieuw, quantity: qty }]); })
      .then(toon)
      .catch(function (err) {
        // Nieuwe maat lukte niet: de oude terugzetten zodat er niets verdwijnt
        return voegToe([{ id: oud, quantity: qty }]).then(toon).catch(function () {}).then(function () {
          melding((err && err.description) || 'Die maat lukte niet. Probeer het opnieuw.');
        });
      })
      .then(function () { laden(false); });
  });

  // Maak je look af: maat kiezen en toevoegen
  document.addEventListener('click', function (e) {
    var m = e.target.closest && e.target.closest('.fzl-look__maat');
    if (m && !m.disabled) {
      var kaart = m.closest('[data-fzl-look]');
      [].forEach.call(kaart.querySelectorAll('.fzl-look__maat'), function (b) { b.classList.toggle('is-gekozen', b === m); });
      var k = kaart.querySelector('[data-fzl-voeg]');
      k.dataset.id = m.dataset.id; k.disabled = false; k.textContent = k.dataset.klaar || '+ Toevoegen';
      return;
    }
    var v = e.target.closest && e.target.closest('[data-fzl-voeg]');
    if (v && !v.disabled && v.dataset.id) {
      v.disabled = true; v.textContent = 'Bezig…'; laden(true);
      voegToe([{ id: +v.dataset.id, quantity: 1 }]).then(toon).catch(function (err) {
        v.disabled = false; v.textContent = v.dataset.klaar || '+ Toevoegen';
        melding((err && err.description) || 'Toevoegen lukte niet. Probeer het opnieuw.');
      }).then(function () { laden(false); });
    }
  });

  // Levertijd: alleen de verwachte bezorgdag, zelfde berekening als het leverblok op de productpagina (geen afteltimer)
  var DAGEN = ['zondag','maandag','dinsdag','woensdag','donderdag','vrijdag','zaterdag'];
  var MND = ['januari','februari','maart','april','mei','juni','juli','augustus','september','oktober','november','december'];
  function ams() {
    var p = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { y: +p.year, m: +p.month, d: +p.day, h: +p.hour % 24 };
  }
  function iso(d) { return d.getUTCFullYear() + '-' + ('0' + (d.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + d.getUTCDate()).slice(-2); }
  function pasen(y) { var a=y%19,b=Math.floor(y/100),c=y%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),mo=Math.floor((h+l-7*m+114)/31),da=((h+l-7*m+114)%31)+1;return Date.UTC(y,mo-1,da); }
  var cache = {};
  function feest(y) {
    if (cache[y]) return cache[y];
    var E = pasen(y), D = 864e5, kd = new Date(Date.UTC(y, 3, 27));
    if (kd.getUTCDay() === 0) kd = new Date(Date.UTC(y, 3, 26));
    return cache[y] = [Date.UTC(y,0,1), E+D, kd.getTime(), E+39*D, E+50*D, Date.UTC(y,11,25), Date.UTC(y,11,26)].map(function (t) { return iso(new Date(t)); });
  }
  function werkdag(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && feest(d.getUTCFullYear()).indexOf(iso(d)) < 0; }
  function bezorgdag(d) { return d.getUTCDay() !== 0 && feest(d.getUTCFullYear()).indexOf(iso(d)) < 0; }
  function na(d, ok) { var n = new Date(d.getTime()); do { n = new Date(n.getTime() + 864e5); } while (!ok(n)); return n; }
  function dag() {
    var els = document.querySelectorAll('[data-fzl-lev] [data-fzl="dag"]:not([data-gezet])');
    if (!els.length) return;
    var a = ams(), vandaag = new Date(Date.UTC(a.y, a.m - 1, a.d));
    [].forEach.call(els, function (el) {
      var uur = parseInt(el.closest('[data-fzl-lev]').dataset.uur, 10) || 16;
      var verzend = (werkdag(vandaag) && a.h < uur) ? vandaag : na(vandaag, werkdag), b = na(verzend, bezorgdag);
      el.textContent = DAGEN[b.getUTCDay()] + ' ' + b.getUTCDate() + ' ' + MND[b.getUTCMonth()];
      el.setAttribute('data-gezet', '');
    });
  }
  dag();
  // De lade wordt na elke wijziging opnieuw opgebouwd: dan de bezorgdag meteen weer invullen
  if (window.MutationObserver) new MutationObserver(dag).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) return;
    [].forEach.call(document.querySelectorAll('[data-fzl="dag"][data-gezet]'), function (el) { el.removeAttribute('data-gezet'); });
    dag();
  });
})();
